import { Dir } from '../interface'

// 查询所有上级目录
export const findPath = (
  dirs: Dir[],
  targetSlug: string,
  path: { name: string; slug: string }[] = [],
  level = 1,
): { name: string; slug: string }[] | undefined => {
  for (const dir of dirs) {
    const newPath = [...path, { name: dir.name, slug: dir.slug }]
    if (dir.slug === targetSlug) return level === 1 ? [] : newPath
    if (dir.sub_dir) {
      for (const item of dir.sub_dir) {
        if ('fox_support_arts' in item) {
          for (const art of item.fox_support_arts) {
            if (art.slug === targetSlug) return newPath
          }
        }
        if ('fox_support_dirs' in item) {
          if (item.fox_support_dirs.find((item) => item.slug === targetSlug)) return newPath
          const result = findPath(item.fox_support_dirs, targetSlug, newPath, level + 1)
          if (result) return result
        }
      }
    }
  }
}
